import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { HighlightOffRounded } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import { QRCodeSVG } from "qrcode.react";
import { useAuth } from "../../../items/AuthProvider";

export default function QRcode(props) {
  const { t } = useTranslation();
  const { user } = useAuth();

  const { show, onHide, qrData, setShow } = props;

  const [qrCodeContent, setQRData] = useState(null);

  useEffect(() => {
    if (user && show) {
      const qrCodeContent = JSON.stringify({
        _id: user._id,
        pd: qrData,
      });

      console.log("qrCodeContent", qrCodeContent);
      setQRData(qrCodeContent);
    }
  }, [user, show]);

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Body className="ui-bg-color promo-modal">
        <HighlightOffRounded
          className="close_circle_icon"
          style={{ fontSize: "40px", marginTop: "0px" }}
          onClick={() => {
            props.onHide();
          }}
        />
        <div
          id="close_promo_modal"
          onClick={() => {
            props.onHide();
          }}
        ></div>
        <Container>
          <div className="d-flex flex-column align-items-center justify-content-center mt-4 pb-4">
            <div className="promo-text mb-5">{t(`Your QR Code`)}</div>
            {qrCodeContent && (
              <div className="mb-4">
                <QRCodeSVG
                  value={qrCodeContent}
                  size={256}
                  level={"H"}
                  className="mx-auto"
                />
              </div>
            )}
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
